import { api } from "@/lib/api";

export interface TaskSubStatus {
	id: string;
	key: string;
	name: string;
	parent_status: string;
	color: string;
	position: number;
	is_system: boolean;
	created_at?: string;
	updated_at?: string;
}

export interface CreateTaskSubStatusPayload {
	name: string;
	parent_status: string;
	color?: string;
	position?: number;
}

export interface UpdateTaskSubStatusPayload {
	name?: string;
	parent_status?: string;
	color?: string;
	position?: number;
}

export async function listTaskSubStatuses(): Promise<TaskSubStatus[]> {
	const res = await api.get<{
		success: boolean;
		data: { task_sub_statuses: TaskSubStatus[] };
	}>("/task-sub-statuses");
	return res.data.task_sub_statuses;
}

export async function createTaskSubStatus(
	payload: CreateTaskSubStatusPayload,
): Promise<TaskSubStatus> {
	const res = await api.post<{
		success: boolean;
		data: { task_sub_status: TaskSubStatus };
	}>("/task-sub-statuses", payload);
	return res.data.task_sub_status;
}

export async function updateTaskSubStatus(
	id: string,
	payload: UpdateTaskSubStatusPayload,
): Promise<TaskSubStatus> {
	const res = await api.patch<{
		success: boolean;
		data: { task_sub_status: TaskSubStatus };
	}>(`/task-sub-statuses/${id}`, payload);
	return res.data.task_sub_status;
}

export async function deleteTaskSubStatus(id: string): Promise<void> {
	await api.delete(`/task-sub-statuses/${id}`);
}
